// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-upload-list{padding-bottom:2rem}.file-upload-gallery{padding:0 0 1rem}.file-upload .file-list{flex:0 1 auto;position:relative;min-height:1px;padding-right:15px;padding-left:15px;width:25%;float:left}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
